import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Button } from '../../../../common/button-new';
import { CvBannerProps } from './cv-banner.models';
import { useStyles } from './cv-banner.styles';
import { cx } from '../../../../../utils';
import { ReactComponent as Image } from '../../../../../assets/images/cv/check-in-eye-gradient.svg';
import { ContentWrapper } from '../../../../common/content-wrapper';
import { convertDateToUIString } from '../../../../../utils/date/convert-date-to-string';

export const CvBanner = ({
  onAction, points, date, withoutPadding, rootClasses,
}: CvBannerProps): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const formattedDate = convertDateToUIString(date) ?? '';

  return (
    <ContentWrapper withoutPaddings={withoutPadding}>
      <div className={cx(classes.root, rootClasses)} data-testid="cv-banner">
        {!isMobile && <Image className={classes.image} data-testid="cv-banner-image" aria-hidden="true" />}
        <h2 className={cx('title-bold', classes.title, classes.textAligned)} data-testid="cv-banner-title">
          <FormattedMessage id="controlVisit.notification.title" values={{ date: formattedDate, points, noBreak: <>&nbsp;</> }} />
        </h2>
        <p className={cx(classes.text, classes.textAligned)} data-testid="cv-banner-description">
          <FormattedMessage id="controlVisit.notification.description" />
        </p>
        {!isMobile && (
          <p className={cx(classes.disclaimer, classes.textAligned)} data-testid="cv-banner-disclaimer">
            <FormattedMessage id="controlVisit.notification.disclaimer" />
          </p>
        )}
        <Button
          testId="cv-banner-more-details"
          onClick={onAction}
          style="text"
          rootClasses={classes.button}
        >
          <FormattedMessage id="common.moreDetails" />
        </Button>
        {isMobile && <Image className={classes.image} data-testid="cv-banner-image" aria-hidden="true" />}
        {isMobile && (
          <p className={cx(classes.disclaimer, classes.textAligned)} data-testid="cv-banner-disclaimer">
            <FormattedMessage id="controlVisit.notification.disclaimer" />
          </p>
        )}
      </div>
    </ContentWrapper>
  );
};
